import { render, staticRenderFns } from "./DashboardChartAccess.vue?vue&type=template&id=296d6c6a&scoped=true"
import script from "./DashboardChartAccess.vue?vue&type=script&lang=js"
export * from "./DashboardChartAccess.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartAccess.vue?vue&type=style&index=0&id=296d6c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d6c6a",
  null
  
)

export default component.exports